module.exports = vendor_eb6e8e343d778eaa8971;